import { FC } from 'react';
import { Box } from '@chakra-ui/react';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';
import OpenHelpButtonLink from 'features/Help/components/OpenHelpButtonLink';
import ApplicationProblemImage from 'features/Onboarding/components/ApplicationProblemImage';

import Page from '../../components/Page';
import PageProps from '../PageProps';
import locales from './locales';

const ShareholdersOnlyCorporateOfficer: FC<PageProps> = () => (
  <Page withNoBackButton>
    <Box>
      <ApplicationProblemImage />

      <Heading marginBottom="space-16" size="lg">
        {locales.title}
      </Heading>

      <Text marginBottom="space-32" variant="primary">
        {locales.description}
      </Text>

      <OpenHelpButtonLink isExpanded>{locales.contactUsCta}</OpenHelpButtonLink>
    </Box>
  </Page>
);

export default ShareholdersOnlyCorporateOfficer;
